module.exports = __webpack_public_path__ + "static/img/case2_4.png";